export default ({ request }) => ({
  orderInfoListApi(data = {}) {
    return request({
      url: '/factory/orderInfo/list',
      method: 'post',
      data,
    })
  },
  orderInfoListByUserApi(data = {}) {
    return request({
      url: '/factory/orderInfo/listByUser',
      method: 'post',
      data,
    })
  },
  orderInfoChangeListByUserApi(data = {}) {
    return request({
      url: '/factory/orderInfo/change/listByUser',
      method: 'post',
      data,
    })
  },
  orderInfoDetailApi(data = {}) {
    return request({
      url: '/factory/orderInfo/detail',
      method: 'post',
      data,
    })
  },
  orderInfoPartDetailApi(data = {}) {
    return request({
      url: '/factory/orderInfo/part/detail',
      method: 'post',
      data,
    })
  },
  orderInfoAddSaveApi(data = {}) {
    return request({
      url: '/factory/orderInfo/add/save',
      method: 'post',
      data,
    })
  },
  orderInfoEditSaveApi(data = {}) {
    return request({
      url: '/factory/orderInfo/edit/save',
      method: 'post',
      data,
    })
  },
  orderInfoDelApi(data = {}) {
    return request({
      url: '/factory/orderInfo/del',
      method: 'post',
      data,
    })
  },
  orderInfoSubmitApi(data = {}) {
    return request({
      url: '/factory/orderInfo/submit',
      method: 'post',
      data,
    })
  },
  orderInfoCopyApi(data = {}) {
    return request({
      url: '/factory/orderInfo/copy',
      method: 'post',
      data,
    })
  },
  orderInfoChangeSalesApi(data = {}) {
    return request({
      url: '/factory/orderInfo/changeSales',
      method: 'post',
      data,
    })
  },
  orderInfoChangeBizApi(data = {}) {
    return request({
      url: '/factory/orderInfo/changeBiz',
      method: 'post',
      data,
    })
  },
})
